import { render, staticRenderFns } from "./login-term.vue?vue&type=template&id=c3ca5e04&"
import script from "./login-term.vue?vue&type=script&lang=js&"
export * from "./login-term.vue?vue&type=script&lang=js&"
import style0 from "./login-term.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports